import React, { useState, useEffect  } from 'react';
import { Helmet } from 'react-helmet';
import { message, Spin  } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import NavBar from '../components/PersonnelData/NavBar';
import API_URL from '../utils/api';
import PersonnelDataContent from '../components/PersonnelData/PersonnelDataContent';

function PersonnelData() {
	useEffect(() => {
		
	}, []);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
		
	

	return (
		<div>
			<Helmet>
				<title>Мои кадровые данные - Личный кабинет Enter Engineering</title>
			</Helmet>			
			<div className='dashboard'>
				<NavBar />
				<div className='dashboard-content'>
					{loading && (<div className='loader-container'>
						<Spin size="large"/>
					</div>)}
                    <PersonnelDataContent />
				</div>
			</div>
		</div>
	);
}

export default PersonnelData;
